//============================================================================================================
//  GLOBAL VARS
//============================================================================================================

var fancyOverlayColor = '#fff';
var fancyOverlayOpacity = 0.75;
var rating = 4.3;

//============================================================================================================
//  DOCUMENT READY
//============================================================================================================
$(document).ready(function () {

    initWaterInputs();
    initClickableBackground();

    initProductDetailsFunction();
    initMyAccountFunctions();
    initCheckoutFunction();

    formatPrices();

});
//============================================================================================================
//  DOCUMENT READY END
//============================================================================================================
//============================================================================================================
function initMyAccountFunctions() {
    if (typeof (InitMyAccountFunctions) == "function")
        InitMyAccountFunctions();
}
//============================================================================================================
function initCheckoutFunction() {
    if (typeof (InitCheckoutFunctions) == "function")
        InitCheckoutFunctions();
}
//============================================================================================================
function initProductDetailsFunction() {
    if (typeof (initProductDetails) == "function")
        initProductDetails();
}
//============================================================================================================
function initWaterInputs() {
    if ($(".waterInput").length < 1)
        return;

    $(".waterInput").each(function () {
        var val = $(this).attr("data-name");
        $(this).watermark(val);
    });
}
//============================================================================================================
function initClickableBackground() {
    if ($(".site-background .x-htmlarea ul li a").length < 1)
        return;

    $(".site-container").click(function (e) {
        if ($(e.target)[0] == $(".site-container")[0]) {
            window.location = $(".site-background .x-htmlarea ul li a").attr("href");
        }
    });
}
//============================================================================================================
function UpdateQueryString(key, value, url) {

    if (!url) url = window.location.href;

    // dirty fix for new url rewriter, remove page number to go back to page 1
    url = url.replace(/\/{1}p{1}[0-9]+/, '');

    var re = new RegExp("([?|&])" + key + "=.*?(&|#|$)", "gi");

    if (url.match(re)) {
        if (value)
            var value = url.replace(re, '$1' + key + "=" + value + '$2');
        else
            var value = url.replace(re, '$2');

        if (value.indexOf('?') == -1) { // convert first paramter separator to query params separator
            var pos = value.indexOf('&');
            if (pos != -1) // has at least one parameter
                value = value.substring(0, pos - 1) + '?' + value.substring(pos + 1, value.length);
        }
        return value;
    }
    else {
        if (value) {
            var separator = url.indexOf('?') !== -1 ? '&' : '?',
                hash = url.split('#');
            url = hash[0] + separator + key + '=' + value;
            if (hash[1]) url += '#' + hash[1];
            return url;
        }
        else
            return url;
    }
}
//============================================================================================================
function getQueryStringValueByName(name) {
    name = name.replace(/[\[]/, "\\\[").replace(/[\]]/, "\\\]");
    var regexS = "[\\?&]" + name + "=([^&#]*)";
    var regex = new RegExp(regexS);
    var results = regex.exec(window.location.search);
    if (results == null)
        return "";
    else
        return decodeURIComponent(results[1].replace(/\+/g, " "));
}
//============================================================================================================
function removeValueFromCommaSeparatedString(list, value, separator) {
    separator = separator || ",";
    var values = list.split(separator);
    for (var i = 0; i < values.length; i++) {
        if (values[i] == value.replace(/\s+/g, '-')) {
            values.splice(i, 1);
            return values.join(separator);
        }
    }
    return list;
}
//============================================================================================================
function CheckEmail(email) {
    //var filter = /^([a-zA-Z0-9_.-])+@(([a-zA-Z0-9-])+.)+([a-zA-Z0-9]{2,4})+$/;
    var filter = /^([a-zA-Z0-9_.-])+@(([a-zA-Z0-9-])+[.])+([a-zA-Z0-9]{2,20})+$/;
    if (!filter.test(email) || email.trim().length==0) {
        return false;
    }
    else
        return true;
}
//============================================================================================================
function numbersOnly(event) {
    // left arrow, right arrow, tab
    if (event.keyCode == 37 || event.keyCode == 39 || event.keyCode == 9) {
    }
    else if (event.keyCode == 46 || event.keyCode == 8 || event.keyCode == 36 || event.keyCode == 35) { // delete, backspace, home, end
    }
    else {
        if (event.keyCode < 95) {
            if (event.keyCode < 48 || event.keyCode > 57) // numbers
                event.preventDefault();
        }
        else {
            if (event.keyCode < 96 || event.keyCode > 105) // keypad
                event.preventDefault();
        }
    }
}
//============================================================================================================
function preventSpecialCharacter(e) {
    var shiftPressed = e.shiftKey;
    var keyCode = e.keyCode;

    if (shiftPressed) {
        // In Order: '<', '>', '#', '&', '%', '{', '}'
        if (keyCode == 188 || keyCode == 190 || keyCode == 51 || keyCode == 55 || keyCode == 53 || keyCode == 219 || keyCode == 221)
            e.preventDefault();
    } else {
        // In Order: '/', '[', ']', '/(numPad)', '&', '%'
        if (keyCode == 191 || keyCode == 219 || keyCode == 221 || keyCode == 111)
            e.preventDefault();
    }
};
//============================================================================================================
function phoneGROnly(event) {
    numbersOnly(event);
    if ($(event.currentTarget).val().length > 9)
        // delete, backspace, home, end, left arrow, right arrow, tab
        if (event.keyCode == 46 || event.keyCode == 8 || event.keyCode == 36 || event.keyCode == 35 || event.keyCode == 37 || event.keyCode == 39 || event.keyCode == 9) { }
        else { event.preventDefault(); }
}

function validateEmail(email) {
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
}

function isTouch() {
    return ($('.touch').length > 0);
}

var addressCompare = function (newAdd, oldAdd) {
    var result = true;
	for (var field in newAdd) {
        if ((field in oldAdd) && (typeof newAdd[field] != "object" || newAdd[field] === null) && (typeof oldAdd[field] != "object" || oldAdd[field] === null) && newAdd[field] !== oldAdd[field]) {
			result = false;
			return result;
		}
	}
	return result;
}

var addressSet = function (newAdd, oldAdd) {
    for (var field in newAdd) {
        if ((field in oldAdd) && newAdd[field] !== oldAdd[field])
            oldAdd[field] = newAdd[field];
    }
    return false;
};

var checkProducts = function (newProd, oldProd) {
    var result = true;

    if (newProd.length != oldProd.length) return result = false;

    for (var i = 0; i < newProd.length; i++) {
        if (newProd[i].Id !== oldProd[i].Id || newProd[i].Quantity !== oldProd[i].Quantity) {
            return result = false;
        }
    }

    return result;
};

var clearAffiliatesCookies = function () {
    var cookies = Cookies.getJSON();
 
     for (var key in cookies) {
         if (key.indexOf('markAffiliate') === 0) {
             Cookies.remove(key);
         }
     }
};